<template>
  <div v-if="showBanner" class="ios-install-banner">
    <div class="banner-content">
      <div class="banner-icon">📱</div>
      <div class="banner-text">
        <h4>Install Axefood App</h4>
        <p>Get the best experience by installing our app</p>
      </div>
      <button @click="dismissBanner" class="close-btn">&times;</button>
    </div>
    <div class="ios-steps" v-if="showSteps">
      <div class="steps-content">
        <h5>How to install:</h5>
        <ol>
          <li>Tap the <strong>Share</strong> button <span class="icon">⎋</span></li>
          <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
          <li>Tap <strong>"Add"</strong> to complete</li>
        </ol>
        <button @click="dismissSteps" class="got-it-btn">Got It!</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IOSInstallBanner",
  data() {
    return {
      showBanner: false,
      showSteps: false,
      dismissed: false,
    };
  },
  mounted() {
    this.checkIOSInstallation();
  },
  methods: {
    isIOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },

    isInStandaloneMode() {
      return (
        window.navigator.standalone ||
        window.matchMedia("(display-mode: standalone)").matches
      );
    },

    checkIOSInstallation() {
      const dismissedUntil = localStorage.getItem("iosInstallDismissedUntil");

      // If within cooldown — don't show banner
      if (dismissedUntil && Date.now() < Number(dismissedUntil)) {
        this.showBanner = false;
        return;
      }

      // Clear expired dismissal
      if (dismissedUntil && Date.now() >= Number(dismissedUntil)) {
        localStorage.removeItem("iosInstallDismissedUntil");
      }

      // Show banner only if iOS and not installed
      if (this.isIOS() && !this.isInStandaloneMode()) {
        setTimeout(() => {
          this.showBanner = true;
        }, 5000);
      }
    },

    dismissBanner() {
      // Set dismissal for 24 hours
      const expiration = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem("iosInstallDismissedUntil", expiration.toString());

      // Hide the banner
      this.showBanner = false;
      this.showSteps = false;
    },

    dismissSteps() {
      // Set dismissal for 24 hours
      const expiration = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem("iosInstallDismissedUntil", expiration.toString());

      // Hide the steps and banner
      this.showSteps = false;
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.ios-install-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  font-family: "Poppins", sans-serif;
}

.banner-content {
  background: #ff8d2f;
  color: white;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.banner-icon {
  font-size: 24px;
  margin-right: 12px;
}

.banner-text {
  flex: 1;
}

.banner-text h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
}

.banner-text p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ios-steps {
  background: white;
  padding: 20px;
  border-top: 1px solid #eee;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.steps-content h5 {
  margin: 0 0 12px 0;
  color: #333;
  font-weight: 600;
}

.steps-content ol {
  margin: 0 0 16px 0;
  padding-left: 20px;
  color: #555;
}

.steps-content li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.icon {
  background: #333;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  display: inline-block;
  margin: 0 4px;
}

.got-it-btn {
  background: #ff8d2f;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  width: 100%;
}

.got-it-btn:hover {
  background: #e67e22;
}
</style>
